import { useLocation } from 'react-router-dom';
import { EMPLOYEE_PORTAL_PATH, LEGACY_EMPLOYEE_PORTAL_PATH } from '../constants';

export const useIsMyProfile = () => {
  const { pathname } = useLocation();

  return pathname.includes(EMPLOYEE_PORTAL_PATH) || pathname.includes(LEGACY_EMPLOYEE_PORTAL_PATH);
};
